// eslint-disable-next-line import/no-duplicates
import Swiper from 'swiper';
// eslint-disable-next-line import/no-duplicates
import SwiperCore, { Navigation } from 'swiper/core';

SwiperCore.use([Navigation]);

const createSlider = ($slider, brand) => {
  let mobileSpace = 16;
  let desktopSpace = 32;
  const isMobile = window.innerWidth < 768;

  if (brand === 'dacia' || brand === 'renault-group') {
    mobileSpace = 0;
    desktopSpace = 0;
  }

  if (brand === 'alpine' || brand === 'alpine-f1') {
    desktopSpace = 24;
  }

  if ($slider.querySelectorAll('.swiper-slide').length < 1) {
    return;
  }

  new Swiper($slider, {
    slidesPerView: 1,
    spaceBetween: mobileSpace,
    centeredSlides: isMobile,
    navigation: {
      nextEl: '.js-event-program-slider-button-next',
      prevEl: '.js-event-program-slider-button-prev',
    },
    breakpoints: {
      768: {
        slidesPerView: 'auto',
        spaceBetween: desktopSpace,
      },
      1140: {
        slidesPerView: 3,
        spaceBetween: desktopSpace,
      },
    },
  });
}

export default function initEventProgramSlider() {
  const $containers = document.querySelectorAll('.cp-event-program-widget');

  if (!$containers.length) {
    return;
  }


  [...$containers].forEach(($container) => {
    const brand = $container.getAttribute('data-brand');

    const $slider = $container.querySelector('.js-event-program-slider-container');
    createSlider($slider, brand);
  });
}
